import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2fb8daf7"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UserEnvCheckStage1 = _resolveComponent("UserEnvCheckStage1");
  var _component_UserEnvCheckStage2 = _resolveComponent("UserEnvCheckStage2");
  var _component_UserEnvCheckStage3 = _resolveComponent("UserEnvCheckStage3");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.envCheckService.stage === 1 ? (_openBlock(), _createBlock(_component_UserEnvCheckStage1, {
    key: "1"
  })) : _createCommentVNode("", true), _ctx.envCheckService.stage === 2 ? (_openBlock(), _createBlock(_component_UserEnvCheckStage2, {
    key: "2"
  })) : _createCommentVNode("", true), _ctx.envCheckService.stage === 3 ? (_openBlock(), _createBlock(_component_UserEnvCheckStage3, {
    key: "3"
  })) : _createCommentVNode("", true)]);
}